module.exports = __webpack_public_path__ + "img/gongzhonghao.44c05f3a.png";